const red = {
  300: "#f76161",
  500: "#d84747",
  700: "#bf3535",
};

export default red;
